import Text from 'components/Text'
import React from 'react'

export default function TextBody (props) {
  return (
    <Text
      fs='body'
      {...props}
    />
  )
}
